import { motion } from "framer-motion";

export const ease = [0.16, 1, 0.3, 1];

export const Container = ({ className = "", children }) => (
  <div className={`mx-auto w-full max-w-[1320px] px-5 sm:px-8 lg:px-12 ${className}`}>{children}</div>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

const parent = (delay) => ({ hidden: {}, show: { transition: { staggerChildren: 0.09, delayChildren: delay } } });
const line = { hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 1.1, ease } } };

export const MaskText = ({ lines, as = "h2", className = "", onLoad = false, delay = 0, ...rest }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Tag className={className} variants={parent(delay)} initial="hidden" {...trigger} {...rest}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span className="block" variants={line}>{l}</motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Overline = ({ children, dark = false, className = "" }) => (
  <div className={`font-mono-x inline-flex items-center gap-3 rounded-full px-5 py-2.5 text-sm font-medium uppercase tracking-[0.18em] sm:text-base ${dark ? "bg-[#CCFF00] text-[#060B19]" : "bg-[#1238CE] text-white"} ${className}`} data-testid="section-label">
    <span className={`h-2.5 w-2.5 rounded-full ${dark ? "bg-[#060B19]" : "bg-[#CCFF00]"}`} />
    {children}
  </div>
);

export const Logo = ({ className = "h-9 w-9" }) => (
  <img src="/img/logo-mr.png" alt="Maicon Roberto" className={`${className} object-contain`} />
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const LimeButton = ({ children, className = "", ...rest }) => (
  <button
    className={`group inline-flex items-center gap-3 rounded-full bg-[#CCFF00] py-3 pl-6 pr-3 text-sm font-bold text-[#060B19] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#d8ff3d] hover:shadow-[0_10px_40px_-10px_rgba(204,255,0,0.6)] active:translate-y-0 ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export const ArrowDot = ({ dark = true }) => (
  <span className={`grid h-8 w-8 place-items-center rounded-full transition-transform duration-500 group-hover:rotate-[-45deg] ${dark ? "bg-[#060B19] text-[#CCFF00]" : "bg-white text-[#060B19]"}`}>
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" /></svg>
  </span>
);
